import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

let portalHostname = getBrowserHostName();

export const useHostname = () => {
    const [, setHostname] = useState<string>(portalHostname);

    const handleSetHostname = useCallback(
        (newHostname: string) => {
            portalHostname = newHostname;
            setHostname(newHostname);
        },
        [setHostname]
    );

    return { hostname: portalHostname, setHostname: handleSetHostname };
};

export const useHostnameManager = () => {
    const { search } = useLocation();
    const { setHostname } = useHostname();

    useEffect(() => {
        const params = new URLSearchParams(search);
        const queryHostname = params.get("hostname");

        if (queryHostname) {
            setHostname(queryHostname);
        } else {
            const browserHostName = getBrowserHostName();
            setHostname(browserHostName);
        }
    }, [search, setHostname]);
};

export function getBrowserHostName() {
    const hostName = window.location.hostname;

    // For local development or local BrowserStack debugging
    if (hostName.indexOf("localhost") > -1 || hostName.indexOf("bs-local.com") > -1) {
        return "wg.portals.cloud.visiondsm.com";
    }

    return hostName;
}
